import {
    mdiChevronRight,
    mdiLightbulbOutline,
    mdiMinus,
    mdiPlus,
} from '@mdi/js';
import { useTranslation } from 'react-i18next';

import { Icon } from 'common/components/Icon';
import {
    ListItem,
    ListItemActionText,
    ListItemMedia,
    ListItemSecondaryAction,
    ListItemText,
} from 'common/components/ListItem';
import { ISkillListItemFragment } from 'graphql/types';

interface IProps extends React.ComponentProps<typeof ListItem> {
    addButton?: boolean;
    added?: boolean;
    disabled?: boolean;
    selected?: boolean;
    skill: ISkillListItemFragment;
    onClick?(skill: ISkillListItemFragment): void;
}

export const SkillSelectorListItem = ({
    addButton,
    added,
    disabled,
    selected,
    skill,
    onClick,
    ...other
}: IProps) => {
    const [translate] = useTranslation();
    const { id, name, thumbnail } = skill || {};

    const isDisabled = disabled || (addButton && added);

    let mediaIconPath = mdiLightbulbOutline;

    if (addButton && !added) {
        mediaIconPath = selected ? mdiMinus : mdiPlus;
    }

    return (
        <ListItem
            button={!isDisabled}
            key={id}
            px={0}
            selected={!isDisabled && selected}
            sx={isDisabled ? { opacity: 0.5, cursor: 'default' } : undefined}
            onClick={() => !isDisabled && onClick?.(skill)}
            {...other}
        >
            <ListItemMedia
                color="primary"
                image={thumbnail?.url || ''}
                size="small"
            >
                <Icon path={mediaIconPath} size="3rem" />
            </ListItemMedia>

            <ListItemText primary={name} />

            {!addButton && !isDisabled && (
                <>
                    <ListItemActionText>{translate('open')}</ListItemActionText>
                    <ListItemSecondaryAction>
                        <Icon path={mdiChevronRight} size="3rem" />
                    </ListItemSecondaryAction>
                </>
            )}
        </ListItem>
    );
};
